// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-views-404-tsx": () => import("./../src/views/404.tsx" /* webpackChunkName: "component---src-views-404-tsx" */),
  "component---src-views-index-tsx": () => import("./../src/views/index.tsx" /* webpackChunkName: "component---src-views-index-tsx" */),
  "component---src-views-search-tsx": () => import("./../src/views/search.tsx" /* webpackChunkName: "component---src-views-search-tsx" */),
  "component---src-views-search-result-tsx": () => import("./../src/views/search/result.tsx" /* webpackChunkName: "component---src-views-search-result-tsx" */)
}

